import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MonitorStatus } from '../../model/monitoring.model';
import * as moment from 'moment';
import { Device } from '../../model/device.model';
import { MonitoringService } from '../../service/monitoring.service';

@Component({
  selector: 'app-monitoring-card',
  templateUrl: './monitoring-card.component.html',
  styleUrls: ['./monitoring-card.component.less']
})
export class MonitoringCardComponent implements OnInit {
  @Input() device: Device;
  @Input() monitor: MonitorStatus;

  logo = true

  moment = require('moment/moment');
  constructor() { }

  ngOnInit() {
    setInterval(() => {
      this.logo = !this.logo
    }, 5000)
  }

}



// WEBPACK FOOTER //
// ./src/app/element/monitoring-card/monitoring-card.component.ts